import React from 'react';

import './WeeklyReportPatients.css';

interface WeeklyReportPatientsProps {
  header: string | React.ReactNode;
  patients: string[];
}

const WeeklyReportPatients: React.FC<WeeklyReportPatientsProps> = ({
  header,
  patients
}) => {
  if (patients.length === 0) return null;

  return (
    <div className="weekly-report-patients">
      <h4 className="weekly-report-patients__header">{header}</h4>
      <div className="weekly-report-patients__list">
        {patients.sort().map((patient) => (
          <div key={patient} className="weekly-report-patients__item">
            {patient}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyReportPatients;
